import apiFetch from '../apiFetch'

export default function (token, faqId) {
  return apiFetch({ endPoint: `Faq/${faqId}`, method: 'DELETE', body: null, token: token })
}
